export const getType = (namespace) => {
  switch (namespace) {
    case 'locations':
      return 'location';
    case 'archives':
      return 'document';
    case 'events':
      return 'event';
    case 'entities':
      return 'stakeholder';
    default:
  }
}
